var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Expand"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.591 4.71216L10.2123 11.0908C10.0952 11.208 9.9052 11.208 9.78804 11.0908L3.40941 4.71221C3.22041 4.5232 3.35427 4.20004 3.62156 4.20004L16.3788 4.2C16.6461 4.2 16.78 4.52316 16.591 4.71216ZM16.3788 3C17.7152 3 18.3844 4.61573 17.4395 5.56069L11.0609 11.9393C10.4751 12.5251 9.52531 12.5251 8.93951 11.9393L2.56089 5.56074C1.61593 4.61578 2.28518 3.00004 3.62155 3.00004L16.3788 3ZM17.4244 11.4248C17.6588 11.1904 17.6588 10.8105 17.4245 10.5762C17.1901 10.3419 16.8102 10.3419 16.5759 10.5762L10.283 16.8687C10.1268 17.0249 9.87355 17.0249 9.71734 16.8687L3.42443 10.5762C3.19011 10.3419 2.81021 10.3419 2.5759 10.5762C2.34159 10.8105 2.34161 11.1904 2.57593 11.4248L8.86884 17.7173C9.49367 18.3421 10.5067 18.3421 11.1315 17.7173L17.4244 11.4248Z",
    fill: "#737373"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.a410784df9df770627b58e71a29d594a.svg";
export { ForwardRef as ReactComponent };